import React from 'react';
import './Card.css';

export default function Card({
  children,
  title,
  subtitle,
  actions,
  className = '',
  padding = true,
  ...props
}) {
  return (
    <div className={`card ${className}`} {...props}>
      {(title || subtitle || actions) && (
        <div className="card-header">
          <div>
            {title && <h3 className="card-title">{title}</h3>}
            {subtitle && <p className="card-subtitle">{subtitle}</p>}
          </div>
          {actions && <div className="card-actions">{actions}</div>}
        </div>
      )}
      <div className={padding ? 'card-body' : 'card-body-no-padding'}>
        {children}
      </div>
    </div>
  );
}


